import { SET_CUTOFFS } from './types';

const cutoffs = (state = null, action) => {
  switch (action.type) {
    case SET_CUTOFFS:
      return action.cutoffs;
    default:
      return state;
  }
};

export default cutoffs;
